import { render, staticRenderFns } from "./AddProvider.vue?vue&type=template&id=2266c266&scoped=true"
import script from "./AddProvider.vue?vue&type=script&lang=js"
export * from "./AddProvider.vue?vue&type=script&lang=js"
import style0 from "./AddProvider.vue?vue&type=style&index=0&id=2266c266&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266c266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2266c266')) {
      api.createRecord('2266c266', component.options)
    } else {
      api.reload('2266c266', component.options)
    }
    module.hot.accept("./AddProvider.vue?vue&type=template&id=2266c266&scoped=true", function () {
      api.rerender('2266c266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/AddProvider.vue"
export default component.exports